import PopupClass from "./components/common/PopupClass";
import SignUpFormClass from "./components/website/SignUpFormClass";
import MainNav from "./components/common/MainNav";
import DemoVideoClass from "./components/website/DemoVideoClass";
import { showPassword } from "./helpers/common-helpers";
import { closeSigninPopup } from "./components/common/Main";
import goToTop from "./components/website/go-to-top";

window.addEventListener('DOMContentLoaded', () => {
    new SignUpFormClass();
    new MainNav();
    new DemoVideoClass();
    new PopupClass();

    closeSigninPopup();
    showPassword();
    goToTop();
});
